/* BSD 首页交互（2026-10-14，v2 于 10-15 加“时间与尺码”下单日期计算）：精选裙款标签、细节切换、纪念小信、社群话题弹窗、照片看大图。
   多个首页模块都会引用本文件，这里只初始化一次；主题编辑器里重新加载模块时也能继续工作（事件委托）。 */
(function () {
  if (window.__bsdHomeReady) return;
  window.__bsdHomeReady = true;

  var NOTE_KEY = 'bsd-memory-note';
  var dialog, content, toastEl, toastTimer;

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // 弹窗和提示条挂在 body 上，外面包一层 .bsdh 让首页样式生效
  function ensureDialog() {
    if (dialog) return;
    var host = document.createElement('div');
    host.className = 'bsdh bh-dialog-host';
    host.innerHTML =
      '<dialog class="bh-dialog" aria-labelledby="BhDialogTitle">' +
      '<button type="button" class="bh-dialog-close bh-icon-button" aria-label="Close">×</button>' +
      '<div class="bh-dialog-content"></div></dialog>' +
      '<div class="bh-toast" role="status" aria-live="polite"></div>';
    document.body.appendChild(host);
    dialog = host.querySelector('dialog');
    content = host.querySelector('.bh-dialog-content');
    toastEl = host.querySelector('.bh-toast');
    host.querySelector('.bh-dialog-close').addEventListener('click', function () { dialog.close(); });
    // 点弹窗外面的遮罩关闭
    dialog.addEventListener('click', function (e) {
      if (e.target !== dialog) return;
      var r = dialog.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close();
    });
  }

  function show(html) {
    ensureDialog();
    content.innerHTML = html;
    var title = content.querySelector('[data-bh-dialog-title], h2');
    if (title) title.id = 'BhDialogTitle';
    if (!dialog.open) {
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    }
  }

  function toast(msg) {
    ensureDialog();
    toastEl.textContent = msg;
    toastEl.classList.add('bh-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('bh-show'); }, 2600);
  }

  // ---------- 纪念小信：只存在本机浏览器 ----------
  function readNote() {
    try { return JSON.parse(localStorage.getItem(NOTE_KEY) || 'null'); } catch (e) { return null; }
  }

  function showNoteForm() {
    var note = readNote() || {};
    show(
      '<article class="bh-dialog-article"><span class="bh-eyebrow">A MEMORY YOU CAN PASS ON</span>' +
      '<h2>A little letter<br>to remember this chapter.</h2>' +
      '<form class="bh-note-form" data-bh-note-form novalidate>' +
      '<label>A moment I want to remember<textarea name="moment" maxlength="1200" placeholder="The day, the people, a little detail…">' + esc(note.moment) + '</textarea></label>' +
      '<label>How it felt to be me, right now<textarea name="feeling" maxlength="1200" placeholder="A feeling I want to keep…">' + esc(note.feeling) + '</textarea></label>' +
      '<label>Something I want to tell you, one day<textarea name="wish" maxlength="1200" placeholder="Dear little one…">' + esc(note.wish) + '</textarea></label>' +
      '<button class="bh-button" type="submit">Keep my memory note ♡</button>' +
      '<p class="bh-subtle">Saved only in this browser on this device. Your words are never posted or sent to us.</p>' +
      '</form></article>'
    );
  }

  function showNoteResult(note) {
    var parts = [note.moment, note.feeling, note.wish].filter(Boolean);
    show(
      '<article class="bh-dialog-article"><span class="bh-eyebrow">YOUR MEMORY, KEPT</span>' +
      '<h2>This mattered to me.</h2>' +
      '<div class="bh-note-result"><span class="bh-eyebrow">A MOMENT FROM MY BECOMING</span>' +
      parts.map(function (t) { return '<p>' + esc(t) + '</p>'; }).join('') +
      '<span class="bh-letter-sign">A little piece of this chapter. ♡</span></div>' +
      '<div class="bh-note-actions"><button type="button" class="bh-button" data-bh-note-download>Download my keepsake</button>' +
      '<button type="button" class="bh-text-link" data-memory-note>Edit my words</button>' +
      '<button type="button" class="bh-text-link" data-bh-note-delete>Delete my note</button></div>' +
      '<p class="bh-subtle bh-note-private">Kept in this browser on this device. Only you choose where it goes next.</p></article>'
    );
  }

  function downloadNote() {
    var note = readNote();
    if (!note) return;
    var text = 'MY MEMORY NOTE\nA moment from my becoming\n\n' +
      [note.moment, note.feeling, note.wish].filter(Boolean).join('\n\n') +
      '\n\nBabyShowerDress · The Memory Dress\n';
    var url = URL.createObjectURL(new Blob([text], { type: 'text/plain;charset=utf-8' }));
    var a = document.createElement('a');
    a.href = url;
    a.download = 'my-memory-note.txt';
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-bh-note-form]');
    if (!form) return;
    e.preventDefault();
    var note = {
      moment: form.elements.moment.value.trim(),
      feeling: form.elements.feeling.value.trim(),
      wish: form.elements.wish.value.trim()
    };
    if (!note.moment) {
      form.elements.moment.setCustomValidity('Write a moment you want to remember.');
      form.elements.moment.reportValidity();
      form.elements.moment.addEventListener('input', function () { form.elements.moment.setCustomValidity(''); }, { once: true });
      return;
    }
    try {
      localStorage.setItem(NOTE_KEY, JSON.stringify(note));
      showNoteResult(note);
    } catch (err) {
      toast('This browser could not save your note. Please copy your words before closing.');
    }
  });

  // ---------- v2 时间与尺码：按活动日期算建议最晚下单日（只在浏览器里算，不提交） ----------
  // 10-15 负责人「这个显示的逻辑也修」：以前选了已过去的日期也显示“日期快到了”，清空日期后旧结果还留着。
  // 现在按顺序判断：没选（或年份还没输完）→ 初始提示；今天或更早 → 请选今天之后；不到 N 周 → 请先联系；
  // 美国来得及、其他地区来不及 → 只给美国日期；都来得及 → 两个日期。
  function plannerToday() {
    var t = new Date();
    t.setHours(0, 0, 0, 0);
    return t;
  }
  function plannerIso(d) {
    return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
  }
  function plannerUpdate(input) {
    var card = input.closest('[data-bh-planner]');
    if (!card) return;
    var out = card.querySelector('[data-bh-planner-result]');
    // 提醒类结果（日期已过、来不及）用左侧色条样式
    var notice = function (text) {
      out.textContent = text;
      out.classList.add('bh-planner-result--soon');
    };
    out.classList.remove('bh-planner-result--soon');
    var p = (input.value || '').split('-');
    var year = Number(p[0]);
    // 手动输入年份时浏览器会先给出 0002、0020 这样的值，年份没输完前按“还没选”处理
    var day = p.length === 3 && year >= 1900 ? new Date(year, Number(p[1]) - 1, Number(p[2])) : null;
    // 日期框里统一显示英文（不跟浏览器语言走）
    var shown = card.querySelector('[data-bh-planner-display]');
    if (shown) {
      var ok = day && !isNaN(day.getTime());
      shown.textContent = ok ? day.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : 'mm/dd/yyyy';
      shown.classList.toggle('is-set', !!ok);
    }
    if (!day || isNaN(day.getTime())) {
      out.textContent = card.getAttribute('data-msg-empty');
      plannerVisual(card, out, null);
      return;
    }
    var today = plannerToday();
    if (day <= today) {
      notice(card.getAttribute('data-msg-past'));
      plannerVisual(card, out, null);
      return;
    }
    var weeksUs = Number(card.getAttribute('data-weeks-us') || 4);
    var weeksIntl = Number(card.getAttribute('data-weeks-intl') || 5);
    var us = new Date(day); us.setDate(us.getDate() - weeksUs * 7);
    var intl = new Date(day); intl.setDate(intl.getDate() - weeksIntl * 7);
    var fmt = function (d) {
      return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: d.getFullYear() !== today.getFullYear() ? 'numeric' : undefined });
    };
    if (us < today) {
      notice(card.getAttribute('data-msg-soon'));
      plannerVisual(card, out, null);
      return;
    }
    plannerVisual(card, out, { today: today, day: day, us: us });
    // 美国还来得及、其他地区已来不及：只给美国日期，其他地区提示先联系
    var msg = intl < today ? card.getAttribute('data-msg-us-only') : card.getAttribute('data-msg');
    out.innerHTML = esc(msg)
      .replace('{us}', '<strong>' + esc(fmt(us)) + '</strong>')
      .replace('{intl}', '<strong>' + esc(fmt(intl)) + '</strong>');
  }
  // 10-22 计划卡样式 B（两张日历页）和 C（进度条）：有日期就画图、把文字结果收起；没日期、日期已过或来不及时恢复占位并显示提示文字。
  // 送达时间按政策事实表：发货 2–4 个工作日 + 运输 5–10 个工作日，从最晚下单日往后数 7–14 个工作日。
  function plannerAddBiz(d, n) {
    var x = new Date(d);
    var c = 0;
    while (c < n) {
      x.setDate(x.getDate() + 1);
      if (x.getDay() !== 0 && x.getDay() !== 6) c++;
    }
    return x;
  }
  function plannerVisual(card, out, v) {
    var cal = card.querySelector('[data-bh-cal]');
    var track = card.querySelector('[data-bh-track]');
    if (!cal && !track) return;
    var q = function (root, sel) { return root.querySelector(sel); };
    // 10-24：月和日之间用不换行空格，跨月区间「Dec 28–Jan 6」只会在横线后折行，不会把「Jan」和「6」拆开
    var md = function (d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }).replace(' ', '\u00A0'); };
    out.hidden = !!v;
    if (cal) {
      cal.classList.toggle('is-set', !!v);
      var fill = function (pre, d, mDef, wDef) {
        var m = q(cal, '[data-cal="' + pre + 'm"]'), dd = q(cal, '[data-cal="' + pre + 'd"]'), w = q(cal, '[data-cal="' + pre + 'w"]');
        m.textContent = d ? d.toLocaleDateString('en-US', { month: 'short' }).toUpperCase() : mDef;
        dd.textContent = d ? d.getDate() : '—';
        w.textContent = d ? d.toLocaleDateString('en-US', { weekday: 'long' }) : wDef;
      };
      fill('o', v && v.us, 'ORDER', 'by date');
      fill('d', v && v.day, 'YOUR', 'big day');
    }
    if (track) {
      var labels = ['l0', 'l1', 'l2', 'l3'];
      var big = q(card, '[data-tr="big"]');
      // 10-22 计划卡电脑版重做：右栏结果卡顶上的大字两项（最晚下单日、送达区间），只在电脑显示，日期和时间线用的是同一组
      var sum = q(card, '[data-tr="sum"]');
      track.classList.toggle('is-set', !!v);
      if (!v) {
        labels.forEach(function (k) { q(card, '[data-tr="' + k + '"]').textContent = '—'; });
        q(track, '[data-tr="fill"]').style.width = '0';
        ['d0', 'd1', 'd2', 'd3'].forEach(function (k, i) { q(track, '[data-tr="' + k + '"]').style.left = (i * 100 / 3) + '%'; });
        if (big) big.hidden = true;
        if (sum) sum.hidden = true;
        return;
      }
      var a1 = plannerAddBiz(v.us, 7), a2 = plannerAddBiz(v.us, 14);
      var total = v.day - v.today;
      var pos = function (d) { return Math.max(0, Math.min(100, (d - v.today) / total * 100)); };
      q(track, '[data-tr="d0"]').style.left = '0%';
      q(track, '[data-tr="d1"]').style.left = pos(v.us) + '%';
      q(track, '[data-tr="d2"]').style.left = pos(a2) + '%';
      q(track, '[data-tr="d3"]').style.left = '100%';
      q(track, '[data-tr="fill"]').style.width = pos(a2) + '%';
      var range = a1.getMonth() === a2.getMonth() ? md(a1) + '–' + a2.getDate() : md(a1) + '–' + md(a2);
      q(card, '[data-tr="l0"]').textContent = md(v.today);
      q(card, '[data-tr="l1"]').textContent = md(v.us);
      q(card, '[data-tr="l2"]').textContent = range;
      q(card, '[data-tr="l3"]').textContent = md(v.day);
      if (big) {
        big.hidden = false;
        q(big, '[data-tr="bigd"]').textContent = v.us.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
      }
      if (sum) {
        sum.hidden = false;
        q(sum, '[data-tr="so"]').textContent = v.us.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
        q(sum, '[data-tr="sa"]').textContent = range;
      }
    }
  }
  document.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('[data-bh-tabs] [data-tab]');
    if (!tab) return;
    var box = tab.closest('[data-bh-tabs]');
    box.querySelectorAll('[data-tab]').forEach(function (b) { b.setAttribute('aria-selected', b === tab ? 'true' : 'false'); });
    box.querySelectorAll('[data-pane]').forEach(function (p) { p.hidden = p.getAttribute('data-pane') !== tab.getAttribute('data-tab'); });
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-bh-planner-input]')) plannerUpdate(e.target);
  });
  document.addEventListener('input', function (e) {
    if (e.target.matches && e.target.matches('[data-bh-planner-input]')) plannerUpdate(e.target);
  });
  // 10-23 负责人 iPhone 上原生日期框「点了还是没反应」：日期框改成按钮 + 自制日历（bsd-datepicker.js），
  // 原来点日期框调 showPicker 和触屏补开的那段不再需要，已删除；选好日期后自制日历派发 input / change，下面照常计算
  // 日期框最早只能选明天；返回本页时浏览器会恢复已填的日期，按已填日期重新显示结果
  function plannerInit() {
    var tomorrow = plannerToday();
    tomorrow.setDate(tomorrow.getDate() + 1);
    document.querySelectorAll('[data-bh-planner-input]').forEach(function (input) {
      input.min = plannerIso(tomorrow);
      if (input.value) plannerUpdate(input);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', plannerInit);
  else plannerInit();
  window.addEventListener('pageshow', plannerInit);
  document.addEventListener('shopify:section:load', plannerInit);

  // ---------- 横向卡片的左右翻页按钮（按颜色挑）：每次翻一张，到头按钮变灰 ----------
  function scrollNavUpdate(root) {
    var sc = root.querySelector('[data-bh-scroller]');
    if (!sc) return;
    var max = sc.scrollWidth - sc.clientWidth - 2;
    root.querySelectorAll('[data-bh-scroll]').forEach(function (b) {
      var dir = Number(b.getAttribute('data-bh-scroll'));
      b.disabled = dir < 0 ? sc.scrollLeft <= 2 : sc.scrollLeft >= max;
    });
  }
  function scrollNavInit() {
    document.querySelectorAll('[data-bh-scroll-root]').forEach(function (root) {
      var sc = root.querySelector('[data-bh-scroller]');
      if (!sc || sc.__bhNav) return;
      sc.__bhNav = true;
      sc.addEventListener('scroll', function () { scrollNavUpdate(root); }, { passive: true });
      scrollNavUpdate(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scrollNavInit);
  else scrollNavInit();
  window.addEventListener('resize', function () { document.querySelectorAll('[data-bh-scroll-root]').forEach(scrollNavUpdate); });
  document.addEventListener('shopify:section:load', scrollNavInit);

  // ---------- 点击事件统一处理 ----------
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('button, a');
    if (!el) return;

    // 横向卡片翻页
    if (el.hasAttribute('data-bh-scroll')) {
      var navRoot = el.closest('[data-bh-scroll-root]');
      var scroller = navRoot && navRoot.querySelector('[data-bh-scroller]');
      if (!scroller) return;
      var first = scroller.firstElementChild;
      var step = first ? first.getBoundingClientRect().width + parseFloat(getComputedStyle(scroller).columnGap || 0) : scroller.clientWidth * 0.8;
      // 用 scrollTo 并对齐到卡片边：Chrome 在吸附滚动的最右端用 scrollBy 往回会被吸回原位
      var maxLeft = scroller.scrollWidth - scroller.clientWidth;
      var target = Math.round(scroller.scrollLeft / step) * step + Number(el.getAttribute('data-bh-scroll')) * step;
      scroller.scrollTo({ left: Math.max(0, Math.min(maxLeft, target)), behavior: 'smooth' });
      return;
    }

    // 精选裙款标签
    if (el.hasAttribute('data-bh-tab')) {
      var id = el.getAttribute('data-bh-tab');
      var root = el.closest('[data-bh-tabs]');
      if (!root) return;
      root.querySelectorAll('[data-bh-tab]').forEach(function (b) {
        var on = b === el;
        b.classList.toggle('bh-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      root.querySelectorAll('[data-bh-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-bh-panel') !== id;
      });
      return;
    }

    // 细节切换
    if (el.hasAttribute('data-bh-detail')) {
      var key = el.getAttribute('data-bh-detail');
      var box = el.closest('[data-bh-details]');
      if (!box) return;
      box.querySelectorAll('[data-bh-detail]').forEach(function (b) {
        var on = b === el;
        b.classList.toggle('bh-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      box.querySelectorAll('[data-bh-detail-frame]').forEach(function (f) {
        f.hidden = f.getAttribute('data-bh-detail-frame') !== key;
      });
      return;
    }

    // 纪念小信
    if (el.hasAttribute('data-memory-note')) {
      e.preventDefault();
      var saved = readNote();
      if (saved && !(dialog && dialog.open && content.querySelector('[data-bh-note-delete]'))) showNoteResult(saved);
      else showNoteForm();
      return;
    }
    if (el.hasAttribute('data-bh-note-download')) { downloadNote(); return; }
    if (el.hasAttribute('data-bh-note-delete')) {
      try { localStorage.removeItem(NOTE_KEY); } catch (err) {}
      showNoteForm();
      toast('Your memory note has been deleted.');
      return;
    }

    // 社群话题
    if (el.hasAttribute('data-bh-circle')) {
      var tpl = document.querySelector('template[data-bh-circle-content="' + el.getAttribute('data-bh-circle') + '"]');
      if (tpl) show(tpl.innerHTML);
      return;
    }

    // 照片墙看大图
    if (el.hasAttribute('data-bh-lightbox')) {
      var img = el.querySelector('img');
      if (!img) return;
      var src = img.currentSrc || img.src;
      show('<div class="bh-dialog-article bh-lightbox"><h2 class="bh-visually-hidden">Photo</h2><img src="' + esc(src) + '" alt="' + esc(img.alt) + '"></div>');
    }
  });
})();
